import { useEffect, useState } from "react";

const links = [
  { href: "#play", label: "玩法入口" },
  { href: "#feed", label: "今日瓜田" },
  { href: "#hot", label: "热评现场" },
  { href: "#rank", label: "段位榜" },
  { href: "#facts", label: "冷知识" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "sticky top-0 z-50 w-full transition-colors duration-300 " +
        (scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent")
      }
    >
      <div className="shell flex h-16 items-center justify-between gap-4 md:h-20">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5 cursor-pointer">
          <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg leading-none transition-transform group-hover:scale-105">🍉</span>
          <span className="leading-none">
            <span className="block font-heading text-xl font-black tracking-tight text-foreground-950">
              吃瓜王
            </span>
            <span className="block pt-0.5 font-display text-[10px] tracking-[0.28em] text-primary-600">
              CHIGUA · KING
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100/70 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#play" className="btn-primary hidden !px-4 !py-2.5 sm:inline-flex cursor-pointer">
            <i className="ri-play-circle-line mr-1.5 text-base" aria-hidden="true" />
            开始挑战
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="grid h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50/70 text-foreground-900 md:hidden cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50/98 md:hidden">
          <nav className="shell flex flex-col gap-1 py-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100/70 cursor-pointer"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" aria-hidden="true" />
              </a>
            ))}
            <a
              href="#play"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2 w-full cursor-pointer"
            >
              开始挑战
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}